import { render, staticRenderFns } from "./ImageUploadCroppie.vue?vue&type=template&id=834b47bc&scoped=true"
import script from "./ImageUploadCroppie.vue?vue&type=script&lang=js"
export * from "./ImageUploadCroppie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834b47bc",
  null
  
)

export default component.exports